import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { logout } from 'admin/src/reducers/auth';
import type { CheckFeatureFlagPayload, FeatureFlagCheck, FeatureFlagSource } from 'admin/src/types/FeatureFlagCheck';

export type FeatureFlagState = {
  [flag: string]: FeatureFlagCheck;
};

const initialFeatureFlagState: FeatureFlagState = {};

const slice = createSlice({
  name: 'featureFlags',
  initialState: initialFeatureFlagState,
  reducers: {
    setFeatureFlagCheck: (state, action: PayloadAction<FeatureFlagCheck>) => {
      state[action.payload.flag] = action.payload;
    },
    clearFeatureFlagCheck: (state, action: PayloadAction<FeatureFlagCheck>) => {
      delete state[action.payload.flag];
    },
    // This triggers the saga to check the feature flag. See admin/src/sagas/featureFlags.ts
    checkFeatureFlag: {
      reducer: (state, action: PayloadAction<CheckFeatureFlagPayload>) => {
        return {
          ...state,
          [action.payload.flag]: {
            flag: action.payload.flag,
            loading: true,
            enabled: false,
          },
        };
      },
      prepare: (flag: string, source?: FeatureFlagSource) => ({
        payload: { flag, source },
      }),
    },
  },
  extraReducers: (builder) => {
    builder.addCase(logout, () => initialFeatureFlagState);
  },
});

export default slice.reducer;

export const { checkFeatureFlag, setFeatureFlagCheck, clearFeatureFlagCheck } = slice.actions;
